import React, { ChangeEvent, SyntheticEvent } from 'react';
import { UserFilterType } from '../pages/UserList';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    onSubmit: (values: UserFilterType) => void;
    value: UserFilterType;
}

interface StateType {
    value: UserFilterType;
    changed: boolean;
}

type PropType = Props & InjectedIntlProps;

class UserListFilters extends React.Component<PropType, StateType> {
    public constructor(props: PropType) {
        super(props);

        const { id, ext_id, name, email } = props.value;
        this.state = {
            changed: false,
            value: {
                id,
                ext_id,
                name,
                email,
            },
        };
    }

    public componentWillReceiveProps(props: PropType) {
        const { id, ext_id, name, email } = props.value;
        this.setState({changed: false, value: {
            id,
            ext_id,
            name,
            email,
        }});
    }

    private onChange = (name: string) => (e: ChangeEvent<HTMLInputElement>) => {
        this.setState({
            changed: true,
            value: {
                ...this.state.value,
                [name]: e.currentTarget.value,
            },
        });
    }

    private onReset = (e: SyntheticEvent) => {
        e.preventDefault();
        this.setState({value: {
            id: '',
            ext_id: '',
            name: '',
            email: '',
        }}, () => {
            this.props.onSubmit(this.state.value);
        });
    }

    public render() {
        return (
            <form className="row" onSubmit={(e) => { e.preventDefault(); this.props.onSubmit(this.state.value); }} >
                <div className="col-md-2">
                    <input type="text" placeholder={this.props.intl.formatMessage({id: 'module.adminUser.ext_id.title'})} value={this.state.value.ext_id} className="form-control" onChange={this.onChange('ext_id')} />
                </div>
                <div className="col-md-3">
                    <input type="text" placeholder={this.props.intl.formatMessage({id: 'module.adminUser.name.title'})} value={this.state.value.name} className="form-control" onChange={this.onChange('name')} />
                </div>
                <div className="col-md-3">
                    <input type="text" placeholder={this.props.intl.formatMessage({id: 'module.adminUser.email.title'})} value={this.state.value.email} className="form-control" onChange={this.onChange('email')} />
                </div>
                <div className="col-md-2">
                    <button type="submit" className="btn btn-primary btn-block" disabled={!this.state.changed}>
                        {this.props.intl.formatMessage({id: 'common.filter'})}
                    </button>
                </div>
                <div className="col-md-2 form-group">
                    <button className="btn btn-danger btn-block" onClick={this.onReset}>
                        <i className="fa fa-redo" /> {this.props.intl.formatMessage({ id: 'common.clear' })}
                    </button>
                </div>

            </form>
        );
    }
}

export default compose(
    injectIntl,
)(UserListFilters);



// WEBPACK FOOTER //
// ./src/modules/User/components/UserListFilters.tsx